import { Flex, Icon, Text } from "@capioweb/ui-components/src"
import React from "react"
import { SiteSearchFilterContext } from "../../pages/SiteSearchPage/context"
import { PaginationButton } from "./components/PaginationButton"
import { PaginationContext } from "./context/PaginationContext"

export interface PaginationBlockProps {
	onClickHandler?: () => void
}

const PaginationBlockDesktop: React.FC<PaginationBlockProps> = ({ onClickHandler }) => {
	const { activePage, setActivePage } = React.useContext(PaginationContext)
	const { activeItems } = React.useContext(SiteSearchFilterContext)
	const totalPages = Math.ceil(activeItems.length / 10)

	const showPrevPageBtn = Number(activePage) > 1
	const showNextPageBtn = Number(activePage) < totalPages



	const getPagesToDisplay = (activePage: number, totalPages: number) => {
		let start = Number(activePage) > 4 ? Number(activePage) - 1 : 3
		if (totalPages - Number(activePage) < 3) start = totalPages - 4
		return Array.from({ length: totalPages + 1 }, (x, i) => i).slice(
			start,
			start + 3
		)
	}

	const filteredPages =
		totalPages < 7
			? Array.from({ length: totalPages }, (x, i) => i)
			: getPagesToDisplay(Number(activePage), totalPages)

	if (totalPages <= 1) return <></>

	return (
		<Flex
			maxw={62}
			columnGap={1}
			justifyContent="center"
			m="auto"
			display={{ _: "none", m: "flex" }}
		>
			{/* Previous page button*/}
			{showPrevPageBtn && (
				<PaginationButton
					ariaLabel="Previous page"
					onclick={() => {
						setActivePage((Number(activePage) - 1).toString())
						onClickHandler()
					}}
				>
					<Flex m="auto">
						<Icon icon="chevron-left" m="auto" />
					</Flex>
				</PaginationButton>
			)}
			{/* First button, always '1' */}
			{totalPages > 7 ? (
				<>
					<PaginationButton
						bgColor={Number(activePage) === 1}
						onclick={() => {
							setActivePage("1")
							onClickHandler()
						}}
					>
						<Text m="auto" textAlign="center">
							1
						</Text>
					</PaginationButton>
					{/* Second button, always '2' or '...' */}

					<PaginationButton
						bgColor={Number(activePage) === 2}
						onclick={() => {
							Number(activePage) <= 4 && setActivePage("2")
							onClickHandler()
						}}
						// disabled if used as truncate 'button'
						disabled={Number(activePage) > 4}
					>
						<Text m="auto" textAlign="center">
							{Number(activePage) <= 4 ? "2" : "..."}
						</Text>
					</PaginationButton>

					{filteredPages.map((i: number) => {
						if (i > 1 && i < totalPages - 1)
							return (
								<PaginationButton
									bgColor={Number(activePage) === i}
									onclick={() => {
										setActivePage(i.toString())
										onClickHandler()
									}}
									key={i}
								>
									<Text m="auto" textAlign="center" id={"vips"}>
										{i}
									</Text>
								</PaginationButton>
							)
					})}
					{/* Second last button, always totalPages - 1 or '...' */}
					<PaginationButton
						bgColor={Number(activePage) === totalPages - 1}
						// disabled if used as truncate 'button'
						disabled={Number(activePage) <= totalPages - 4}
						onclick={() => {
							Number(activePage) > totalPages - 4 &&
								setActivePage((totalPages - 1).toString())
							onClickHandler()
						}}
					>
						<Text m="auto" textAlign="center">
							{Number(activePage) > totalPages - 4 ? totalPages - 1 : "..."}
						</Text>
					</PaginationButton>
					{/* Last button, always totalPages */}
					<PaginationButton
						bgColor={Number(activePage) === totalPages}
						onclick={() => {
							setActivePage(totalPages.toString())
							onClickHandler()
						}}
					>
						<Text m="auto" textAlign="center">
							{totalPages}
						</Text>
					</PaginationButton>
				</>
			) : (
				<>
					{Array.from({ length: totalPages }, (x, i) => i).map((i: number) => {
						return (
							<PaginationButton
								bgColor={Number(activePage) === i + 1}
								onclick={() => {
									setActivePage((i + 1).toString())
									onClickHandler()
								}}
								key={i}
							>
								<Text m="auto" textAlign="center">
									{i + 1}
								</Text>
							</PaginationButton>
						)
					})}
				</>
			)}
			{/* Next page button*/}
			{showNextPageBtn && (
				<PaginationButton
					ariaLabel="Next page"
					onclick={() => {
						setActivePage((Number(activePage) + 1).toString())
						onClickHandler()
					}}
				>
					<Flex m="auto">
						<Icon icon="chevron-right" m="auto" />
					</Flex>
				</PaginationButton>
			)}
		</Flex>
	)
}

export { PaginationBlockDesktop }
